import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import { Button } from '../Buttons';
import { Icon } from '../Icon';
import { Minus, Plus } from '../Icons';
import { Flex } from '../Layout';
import { Title } from '../Typography';
const OperatorButton = React.memo(function OperatorButton(_ref) {
  let {
    children,
    disabled,
    onClick,
    value,
    type,
    customBackgroundButtonColor,
    customButtonColorText
  } = _ref;
  const borderColor = customBackgroundButtonColor || (disabled ? 'brandLight' : 'background.blue');
  const colorIcon = customButtonColorText || (disabled ? 'background.blue' : 'brandLight');
  return React.createElement(Button, {
    variant: "square",
    size: "medium",
    border: "2px solid",
    borderRadius: "6px",
    opacity: disabled ? '0.2' : '1',
    borderColor: borderColor,
    backgroundColor: borderColor,
    disabled: disabled,
    onClick: () => onClick(value),
    "data-testid": "operator-button--".concat(type)
  }, React.createElement(Icon, {
    color: colorIcon
  }, children));
});
export const Counter = React.memo(function Counter(props) {
  const {
    initialValue,
    minValue,
    maxValue,
    onChange,
    disabled,
    customBackgroundButtonColor,
    customButtonColorText,
    customCardTextColor
  } = props;
  const [value, setValue] = useState(initialValue);
  const onClick = useCallback(op => {
    setValue(p => {
      onChange(p + op);
      return p + op;
    });
  }, []);
  return React.createElement(Flex, {
    alignItems: "center",
    width: "200px"
  }, React.createElement(OperatorButton, {
    disabled: value <= minValue || disabled,
    onClick: onClick,
    value: -1,
    customBackgroundButtonColor: customBackgroundButtonColor,
    customButtonColorText: customButtonColorText,
    type: "minus"
  }, React.createElement(Minus, null)), React.createElement(Title, {
    color: customCardTextColor,
    as: "div",
    margin: "auto",
    flex: 1,
    textAlign: "center"
  }, value), React.createElement(OperatorButton, {
    disabled: value >= maxValue || disabled,
    onClick: onClick,
    value: 1,
    customBackgroundButtonColor: customBackgroundButtonColor,
    customButtonColorText: customButtonColorText,
    type: "plus"
  }, React.createElement(Plus, null)));
});
Counter.propTypes = process.env.NODE_ENV !== "production" ? {
  initialValue: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  minValue: PropTypes.number,
  maxValue: PropTypes.number,
  disabled: PropTypes.bool,
  customBackgroundButtonColor: PropTypes.string,
  customButtonColorText: PropTypes.string,
  customCardTextColor: PropTypes.string
} : {};
Counter.defaultProps = {
  initialValue: 0,
  minValue: 1,
  maxValue: 10,
  disabled: false,
  customBackgroundButtonColor: '',
  customButtonColorText: '',
  customCardTextColor: ''
};